import axiosClient from './axiosClient'

export const getToken = (user, password, axiosErrorHandler = undefined) => {
    let bodyFormData = new FormData();
    bodyFormData.set('username', user);
    bodyFormData.set('password', password);
    
    return axiosClient.post(`/administrators/oauth/token-cookie`, bodyFormData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        errorHandler: axiosErrorHandler,
        withCredentials: true,
        credentials: 'include'
    }).then(response => {
        //this return a cookie with the token
        return response;
    });
}

export const checkExistingSession = (withToken = false) => {
    const url = withToken ? '/administrators/session?withToken=true' : '/administrators/session';
    return axiosClient.get(url, {
        withCredentials: true,
        errorHandler: (error) => {
            return;
        }
    }).then(response => {
        if (!response.data || !response.data.data) {
            return Promise.reject('No session data');
        }
        return response.data.data; 
    });
}